<template>
<div>
<div id="column">
<div class="marginzero heading" ><span><b>Lease Details</b></span>
<input class="clearbutton" type=button value="Clear" @click="clearLeaseDetails()">
</div>
      <div class="card card-height" >
        <div  class="frm-group" >
            <div class="col-15">
                <label for="initialPreTaxLeasePayment"> Initial Pre-Tax Lease Pmt </label>
            </div>
            <div class="col-8">
                <label type="Text" class="labelright">{{calcInitialPretaxLeasePayment}}</label>
            </div>
            <div class="col-15">
                <label for="acquisitionFee"> Acquisition Fee </label>
            </div>
            <div class="col-8">
               <input type="Text" v-model.number=quoteobject.quote.ld_acquisition_fee>
            </div>
            <div class="col-15 marginleft">
                <label for="lessTradeCredit"> Less Trade Credit </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calcLessTradeCredit}}</label>
            </div>
            <div class="col-15">
                <label for="monthlyDepreciation"> Monthly Depreciation </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calcMonthlyDepriciation}}</label>
            </div>

            </div>
        <div  class="frm-group" >
            <div class="col-15">
                <label for="adjToMonthlyLeasePayment"> Adj to Mnly Lease Payment </label>
            </div>
            <div class="col-8">
               <input type="text" v-model.number="quoteobject.quote.ld_adj_to_monthly_lease_payment"  />
            </div>
            <div class="col-15">
                <label for="serviceContractFee"> Service Contract Fee </label>
            </div>
            <div class="col-8">
                <input type="Text"  v-model.number="quoteobject.quote.ld_service_contract_fee"/>
            </div>
           <div class="col-15 marginleft">
                <label for="lessDealerDeposit"> Less Dealer Deposit </label>
            </div>
            <div class="col-8">
                <input type="Text" v-model.number="quoteobject.quote.ld_less_dealer_deposit"  />
            </div>
        </div>
        <div  class="frm-group" >
           <div class="col-15">
                <label for="finalPreTaxMonthlyLeasePayment"> Final PreTax Mly Lease Pmt </label>
            </div>
            <div class="col-8">
                <label type="Text" class="labelright">{{calcFinalPreTaxMonthlyLeasepayment}}</label>
            </div>
           <div class="col-15">
                <label for="taxOnFees"> Tax On Fees </label>
            </div>
            <div class="col-8">
               <input type="Text" v-model.number="quoteobject.quote.ld_tax_on_fees"  />
            </div>
             <div class="col-15 marginleft">
                <label for="cashDueUponSigning"> Cash Due Upon Signing </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calcCashDueUponSign}}</label>
            </div>
        </div>
        <div  class="frm-group" >
           <div class="col-15">
                <label for="taxOnMonthlyTaxLeasePayment"> Tax On Mly Lease Pmt </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calcTaxOnMonthlyLeasePayment}}</label>
            </div>
             <div class="col-15">
                <label for="dealerFee"> Dealer Fee </label>
            </div>
            <div class="col-8">
                <input type="Text" v-model.number="quoteobject.quote.ld_dealer_fee" />
            </div>
            <div class="col-15 marginleft">
                <label for="sumOfLeasePayments"> Sum of Lease Payments </label>
            </div>
            <div class="col-8">
                 <label type="Text" class="labelright">{{calcSumOfLeasePayments}}</label>
            </div>

        </div>
        <div class="frm-group">
            <div class="col-15">
                <label for="finalMonthlyLeasePayment"> Final  Mly Lease Pmt </label>
            </div>
            <div class="col-8">
                <label type="Text" class="labelright">{{calcFinalMonthlyLeasePayment}}</label>
            </div>
            <div class="col-15">
                <label for="estDMVFee"> Est DMV Fee </label>
            </div>
            <div class="col-8">
               <input type="Text" v-model.number="quoteobject.quote.ld_est_dmv_fee" />
            </div>
            <div class="col-15 marginleft">
                <label for="cashDueUponSigning"> Depreciation </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calcDepreciation}}</label>
            </div>

         </div>
        <div  class="frm-group" >
            <div class="col-15">
                <label for="upfrontLeasePaymentDue"> Upfront Lease Pmt Due </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calcUpfrontLeasePaymentDue}}</label>
            </div>
            <div class="col-15">
                <label for="securityDeposit"> Security Deposit </label>
            </div>
            <div class="col-8">
                <input type="Text" v-model.number="quoteobject.quote.ld_security_deposit" />
            </div>
            <div class="col-15 marginleft">
                <label for="sumOfPre-TaxLeasePayments"> Sum of PreTax Lease pmt </label>
            </div>
            <div class="col-8">
                 <label type="Text" class="labelright">{{calcSumOfPretaxLeasePayments}}</label>
            </div>
        </div>
            <div  class="frm-group" >
               <div class="col-15">
                <label for="totalCapCostReduction"> Total Cap Cost Reduction</label>
            </div>
            <div class="col-8">
                <label type="Text" class="labelright">{{calcTotalCapCostReduction}}</label>
            </div>
            <div class="col-15">
                <label for="other"> Other </label>
            </div>
            <div class="col-8">
               <input type="Text"  v-model.number="quoteobject.quote.ld_other" />
            </div>
            <div class="col-15 marginleft">
                <label for="totalRentalCharge"> Total Rental Charge </label>
            </div>
            <div class="col-8">
               <label type="Text" class="labelright">{{calTotalRentalCharge}}</label>
            </div>

                    </div>
        <div  class="frm-group" >
           <div class="col-15">
                <label for="totalCapCostReduction"> Tax Due At Inception</label>
            </div>
            <div class="col-8">
                <label type="Text" class="labelright">{{calTaxDueAtInception}}</label>
            </div>
            <div class="col-15">
                <label for="totalDueUponSigning"> Total Due Upon Signing </label>
            </div>
            <div class="col-8">
                <label type="Text" class="labelright">{{calcTotalDueUponSign}}</label>
            </div>
            <div class="col-15 marginleft">
                <label for="taxOnInitialLeasePayments"> Tax On Initial Lease Payments </label>
            </div>
            <div class="col-8">
                 <label type="Text" class="labelright">{{ calcTaxOnInitialLeasePayments}}</label>
            </div>
        </div>
   </div>
</div>
   <div id="column1">
        <div class="marginzero heading"><span><b>International Autosource Program</b>
        <input type="radio" name="radio1" value="Y" v-model="quoteobject.quote.is_ias_deal" class="maxwidth">Yes
                 <input type="radio" name="radio1" value="N" v-model="quoteobject.quote.is_ias_deal" class="maxwidth">No</span></div>
        <div v-if="this.quoteobject.quote.is_ias_deal== 'Y'">
        <div class="card card-height-vd">
        <div class="frm-group">
        <div class="col-30">
            <label for="program"> Program </label>
            </div>
            <div class="col-15">
            <select name="leaseType" v-model="quoteobject.quote.ias_program">
                     <option > Executive </option>
                      <option > Student</option>
            </select>
            </div>
        <div class="col-30">
            <label for="iasRevShare">IAS Rev Share</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
        </div>
        <div class="frm-group">
            <div class="col-30">
            <label for="llpRate">LLP Rate</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
        <div class="col-30">
            <label for="iasupfront">IAS Upfront</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
            </div>
            <div class="frm-group">
            <div class="col-30">
            <label for="llpRate">Pro Forma Payment to LLP</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
        <div class="col-30">
            <label for="iasupfront">Monthly IAS Rev Share</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
            </div>
        </div></div></div>
        <div id="column1">
        <div class="marginzero heading"><span><b>Portfolio Deals</b>
        <input type="radio" name="radio2" value="Y" v-model="quoteobject.quote.pd_is_portfolio_deal" class="maxwidth">Yes
                 <input type="radio" name="radio2" value="N" v-model="quoteobject.quote.pd_is_portfolio_deal" class="maxwidth">No</span></div>
        <div v-if="this.quoteobject.quote.pd_is_portfolio_deal== 'Y'">
        <div class="card card-height-vd">
        <div class="frm-group">
            <div class="col-30">
            <label for="llpRate">Existing Lease Balances</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
        <div class="col-30">
            <label for="llpRate">Existing Collateral Value</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
        </div>
        <div class="frm-group">
            <div class="col-30">
            <label for="llpRate">Post-Deal Equity</label>
        </div>
        <div class="col-15">
            <label type="Text" class="labelright"></label>
        </div>
        </div>
        </div></div></div>

  <div id="buttonpadding">
    <input id="tabbutton" type="button" value="Clear" @click="clearAll()">
    <input id="tabbutton" type="button" value="Generate" >
    <input id="tabbutton" type="button" value="Save New Quote">
    <input id="tabbutton" type="button" value="Clear" @click="clearAll()">
    <input id="tabbutton" type="button" @click="quoteobject.quote.tabIndex++" value="Next">
    <input  id="tabbutton" type="button" @click="quoteobject.quote.tabIndex--" value="Back">
     <div id="savelaterleasedetails">
       <input type="submit" value="Save Later" id="tabbutton" @click="savelaterpopup()">
         </div>
</div>
<div id="saveleasedetails" class="popup">
         <div class="popup-topcontent" >
              <span>Save Later</span>

            <span class="savelaterleasedetailsclose" id="test">x</span>
            </div>
         <div class="popup-content"> <center>
        <p>Are you sure you want to save this for a later use?</p>
         <input type="submit" value="Yes" id="customerbutton">
         <input type="submit" value="No" id="customerbutton"></center>
              </div>
         </div>
 </div>

      <!-- End of the code for this screen here -->
</template>
<script>
import commonservice from '../js/http-common'
import moment from 'moment'
import vendorintegration from '../js/http-vendorintegration'
export default {
  props: ['quoteobject'],
  components: {

  },
  name: 'DealInputFinancials',
  data () {
    return {
      states: [],
      previous_de_total_payments: '',
      state: '',
      previous_de_initial_equity_target_pct: '',
      previous_de_exit_equity_target_pct: null,
      previous_de_lease_funding_cost_pct: null

    }
  },
  methods: {

    clearAll () {
      this.clearLeaseDetails()
    },

    savelaterpopup () {
      var popup = document.getElementById('saveleasedetails')
      var btn = document.getElementById('savelaterleasedetails')
      var span = document.getElementsByClassName('savelaterleasedetailsclose')[0]
      btn.onclick = function () {
        popup.style.display = 'block'
      }
      span.onclick = function () {
        popup.style.display = 'none'
      }

      window.onclick = function (event) {
        if (event.target == popup) {
          popup.style.display = 'none'
        }
      }
    }
  },
  computed: {
    calcInitialPretaxLeasePayment () {
      if (this.quoteobject.quote.de_lease_funding_cost_pct == 0 || this.quoteobject.quote.de_state_tax_rate_pct == 'key Inputs' || this.quoteobject.quote.vd_llp_final_residual == 'KeyInputs') { return 'key Inputs' } else {
        var a = this.quoteobject.quote.de_lease_funding_cost_pct / 100
        var b = a / 12 + 1
        var c = this.quoteobject.quote.vd_llp_final_residual
        var npv = c / b// fv
        var leasefundingcost = a / 12// rate
        var remainingpayments = this.quoteobject.quote.de_remaining_payments// npr
        var loanamount = -this.quoteobject.quote.lm_loan_amount + this.quoteobject.quote.de_deferred_equity_amount// pv
        var x = Math.pow(1 + leasefundingcost, remainingpayments)

        this.quoteobject.quote.ld_initial_pre_tax_lease_payment = -((leasefundingcost * (npv + x * loanamount)) / (-1 + x))
        return this.quoteobject.quote.ld_initial_pre_tax_lease_payment.toFixed(2)
      }
    },
    calcFinalPreTaxMonthlyLeasepayment () {
      if (this.quoteobject.quote.ld_adj_to_monthly_lease_payment == ' ') { return 'key Inputs' } else {
        this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment = (Number(this.quoteobject.quote.ld_initial_pre_tax_lease_payment) +
                                                                       Number(this.quoteobject.quote.ld_adj_to_monthly_lease_payment)).toFixed(2)

        return this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment
      }
    },
    calcTaxOnMonthlyLeasePayment () {
      if (this.quoteobject.quote.de_state_of_registration == '') { return 'Enter State' } else if (this.quoteobject.quote.de_state_of_registration == 'AZ' || this.quoteobject.quote.de_state_of_registration == 'CA' ||
            this.quoteobject.quote.de_state_of_registration == 'CO' || this.quoteobject.quote.de_state_of_registration == 'CT' ||
            this.quoteobject.quote.de_state_of_registration == 'DE' || this.quoteobject.quote.de_state_of_registration == 'FL' || this.quoteobject.quote.de_state_of_registration == 'IN' ||
            this.quoteobject.quote.de_state_of_registration == 'MA' || this.quoteobject.quote.de_state_of_registration == 'MI' || this.quoteobject.quote.de_state_of_registration == 'NC' ||
            this.quoteobject.quote.de_state_of_registration == 'NH' || this.quoteobject.quote.de_state_of_registration == 'NV' || this.quoteobject.quote.de_state_of_registration == 'TN' ||
            this.quoteobject.quote.de_state_of_registration == 'UT' || this.quoteobject.quote.de_state_of_registration == 'PA' || this.quoteobject.quote.de_state_of_registration == 'WA') {
        this.quoteobject.quote.ld_tax_on_monthly_lease_payment = ((this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment) *
            ((this.quoteobject.quote.de_state_tax_rate_pct) / 100 + (this.quoteobject.quote.de_county_tax_rate_pct) / 100 + (this.quoteobject.quote.de_zip_tax_rate_pct) / 100)).toFixed(2)
        return this.quoteobject.quote.ld_tax_on_monthly_lease_payment
      }
    },
    calcFinalMonthlyLeasePayment () {
      if (this.quoteobject.quote.ld_tax_on_monthly_lease_payment != '' || this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment != '') {
        this.quoteobject.quote.ld_final_monthly_lease_payment = Number(this.quoteobject.quote.ld_tax_on_monthly_lease_payment) + Number(this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment)
        return this.quoteobject.quote.ld_final_monthly_lease_payment
        // console.log(this.quoteobject.quote.ld_final_monthly_lease_payment)
      } else return this.quoteobject.quote.ld_final_monthly_lease_payment
    },
    calcUpfrontLeasePaymentDue () {
      if (this.quoteobject.quote.ld_final_monthly_lease_payment != 0) {
        this.quoteobject.quote.ld_upfront_lease_payment_due = this.quoteobject.quote.ld_final_monthly_lease_payment *
                this.quoteobject.quote.lm_advance_rental_payments
                // console.log(this.quoteobject.quote.ld_upfront_lease_payment_due)
        return this.quoteobject.quote.ld_upfront_lease_payment_due
      } else return this.quoteobject.quote.ld_upfront_lease_payment_due
    },
    calcTotalCapCostReduction () {
      this.quoteobject.quote.ld_total_cap_cost_reduction = this.quoteobject.quote.vd_total_cap_reduction
      return this.quoteobject.quote.ld_total_cap_cost_reduction
    },

    calTaxDueAtInception () {
      if (this.quoteobject.quote.de_state_of_registration == 'NY') {
        this.quoteobject.quote.ld_tax_due_at_inception = this.quoteobject.quote.lm_tax_due_on_cash_cap_red +
                this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost + this.quoteobject.quote.lm
        return this.quoteobject.quote.ld_tax_due_at_inception
      } else if (this.quoteobject.quote.ld_tax_on_monthly_lease_payment > 0) {
        this.quoteobject.quote.ld_tax_due_at_inception = (Number(this.quoteobject.quote.lm_tax_due_on_cash_cap_red) +
                Number(this.quoteobject.quote.lm_tax_due_on_pmts_cap_cost) + Number(this.quoteobject.quote.lm_tax_on_trade)).toFixed(2)
        return this.quoteobject.quote.ld_tax_due_at_inception
      } else if (this.quoteobject.quote.de_is_trade_tax_exempt == 'Y') {
        // console.log("yes")
        this.quoteobject.quote.ld_tax_due_at_inception = (this.quoteobject.quote.vd_cash_cap_reduction - this.quoteobject.quote.vd_trade_value) *
                (this.quoteobject.quote.de_state_tax_rate_pct / 100 + this.quoteobject.quote.de_county_tax_rate_pct / 100 + this.quoteobject.quote.de_zip_tax_rate_pct / 100)
        return this.quoteobject.quote.ld_tax_due_at_inception.toFixed(2)
      } else if (this.quoteobject.quote.vd_trade_value > this.quoteobject.quote.vd_cash_cap_reduction) {
        this.quoteobject.quote.ld_tax_due_at_inception = 0
        return this.quoteobject.quote.ld_tax_due_at_inception
      } else return this.quoteobject.quote.ld_tax_due_at_inception
    },
    calcTotalDueUponSign () {
      this.quoteobject.quote.ld_total_due_upon_signing = Number(this.quoteobject.quote.ld_upfront_lease_payment_due) + Number(this.quoteobject.quote.ld_total_cap_cost_reduction) +
            Number(this.quoteobject.quote.ld_tax_due_at_inception) + this.quoteobject.quote.ld_acquisition_fee + this.quoteobject.quote.ld_service_contract_fee + this.quoteobject.quote.ld_tax_on_fees +
            this.quoteobject.quote.ld_dealer_fee + this.quoteobject.quote.ld_est_dmv_fee + this.quoteobject.quote.ld_security_deposit + this.quoteobject.quote.ld_other
      return this.quoteobject.quote.ld_total_due_upon_signing
    },
    calcLessTradeCredit () {
      if (this.quoteobject.quote.vd_trade_credit != '') {
        this.quoteobject.quote.ld_less_trade_credit = this.quoteobject.quote.vd_trade_credit
        return this.quoteobject.quote.ld_less_trade_credit
      } else return this.quoteobject.quote.ld_less_trade_credit
    },
    calcCashDueUponSign () {
      if (this.quoteobject.quote.ld_total_due_upon_signing != '') {
        this.quoteobject.quote.ld_cash_due_upon_signing = this.quoteobject.quote.ld_total_due_upon_signing -
                                                    (Number(this.quoteobject.quote.ld_less_trade_credit) + this.quoteobject.quote.ld_less_dealer_deposit)
        return this.quoteobject.quote.ld_cash_due_upon_signing
      } else return this.quoteobject.quote.ld_cash_due_upon_signing
    },
    calcSumOfLeasePayments () {
      if (this.quoteobject.quote.ld_final_monthly_lease_payment != '' && this.quoteobject.quote.lm_total_monthly_payment != '') {
        this.quoteobject.quote.ld_sum_of_lease_payments = Math.round(this.quoteobject.quote.ld_final_monthly_lease_payment * this.quoteobject.quote.lm_total_monthly_payment)
        return this.quoteobject.quote.ld_sum_of_lease_payments
      } else return this.quoteobject.quote.ld_sum_of_lease_payments
    },
    calcDepreciation () {
      if (this.quoteobject.quote.vd_lease_cap_cost != '' && this.quoteobject.quote.vd_lease_residual < this.quoteobject.quote.vd_lease_cap_cost) {
        this.quoteobject.quote.ld_depreciation = (this.quoteobject.quote.vd_lease_cap_cost - this.quoteobject.quote.vd_lease_residual).toFixed(2)
        return this.quoteobject.quote.ld_depreciation
      } else return this.quoteobject.quote.ld_depreciation
    },
    calcSumOfPretaxLeasePayments () {
      if (this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment != '' && this.quoteobject.quote.lm_total_monthly_payment != '') {
        this.quoteobject.quote.ld_sum_of_pre_tax_lease_payments = (this.quoteobject.quote.ld_final_pre_tax_monthly_lease_payment * this.quoteobject.quote.lm_total_monthly_payment).toFixed(2)
        return this.quoteobject.quote.ld_sum_of_pre_tax_lease_payments
      } else return this.quoteobject.quote.ld_sum_of_pre_tax_lease_payments
    },
    calTotalRentalCharge () {
      if (this.quoteobject.quote.ld_sum_of_pre_tax_lease_payments != '' && this.quoteobject.quote.ld_depreciation != '') {
        this.quoteobject.quote.ld_total_rental_charge = (this.quoteobject.quote.ld_sum_of_pre_tax_lease_payments - this.quoteobject.quote.ld_depreciation).toFixed(2)
        return this.quoteobject.quote.ld_total_rental_charge
      } else return this.quoteobject.quote.ld_total_rental_charge
    },
    calcTaxOnInitialLeasePayments () {
      if (this.quoteobject.quote.ld_tax_on_monthly_lease_payment != '' && this.quoteobject.quote.lm_advance_rental_payments != '') {
        this.quoteobject.quote.ld_tax_on_initial_lease_payments = this.quoteobject.quote.ld_tax_on_monthly_lease_payment * this.quoteobject.quote.lm_advance_rental_payments
        return this.quoteobject.quote.ld_tax_on_initial_lease_payments
      } else return this.quoteobject.quote.ld_tax_on_initial_lease_payments
    },
    calcMonthlyDepriciation () {
      if (this.quoteobject.quote.ld_depreciation != '' && this.quoteobject.quote.lm_total_monthly_payment) {
        this.quoteobject.quote.ld_monthly_depreciation = Math.round(this.quoteobject.quote.ld_depreciation / this.quoteobject.quote.lm_total_monthly_payment)
        return this.quoteobject.quote.ld_monthly_depreciation
      } else return this.quoteobject.quote.ld_monthly_depreciation
    }

  }
}
</script>
<style scoped>

 .frm-group {
    /** display: -webkit-flex;  **/
    display: flex;
    flex-flow: row;
    align-items: left;
    width:100%;
}
.font12{
    font-size: 12px;
    line-height: 0.5
}
.frm-group label {
    text-align: left;
    font-size: 12px;
    vertical-align: bottom;
    margin: 8px 15px 0px 10px;
    display:block;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.frm-group input {
    width: 100%;
    white-space: nowrap;
    border: 1px solid #ddd;
    border-radius: 5px;
    resize: vertical;
    font-size:12px;
    margin: 5px 10px 0px 0px;
}

.frm-group input[type="Date"]{
    padding: 6px
}
.frm-group input[type="number"]{
    font-size: 12px
}

.frm-group select {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size:12px;
    resize: vertical;
    margin: 5px 10px 0px 0px;

}

#column {
  float: left;
  width: 100%;
  padding: 1px;
}
#column1 {
  float: left;
  width: 50%;
  padding: 1px;
}
.marginleft{
    margin-left: 4.5%
}
.card-height{
height:225px;
padding-top:0px
}
.card-height-vd{
   height:110px;
   padding-top: 0px
}

.col-8{
    float:right;
    width:8%;
    font-size: 12px;
}
.col-17{
   width:17%
}

.maxwidth{
   max-width:10%;
}
.popup {
   display: none;
   position: fixed;
   z-index: 1;
   padding-top: 100px;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   overflow: auto;
   background-color: rgb(0,0,0);
   background-color: rgba(0,0,0,0.4);
   }
   .popup-content {
   overflow: hidden;
    border:1px solid #00529B;
    background:white;
    padding: 10px 0px 10px 0px;
    border-top:none;
    width:45%;
    margin:0px 400px;

   }

   .popup-topcontent{
   background-color: dodgerblue;
   margin: 0px 400px;
   padding: 10px 10px 10px 10px;
   width: 45%;
   border:1px solid #00529B;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
   font-size : 14px;
   color: white;
    margin-top:2%;
   }
   .savelaterleasedetailsclose {
   color: black;
   float: right;
   font-size: 16px;
   font-weight: bold;
   padding: 0px 10px 0px 0px;
   }
   .savelaterleasedetailsclose:hover,
   .savelaterleasedetailsclose:focus {
   color: #000;
   text-decoration: none;
   cursor: pointer;
   }

#tabbutton{
    float:right;
    color: white;
    padding: 6px 20px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    margin: 10px 0px 0px 0px;
}
#buttonpadding{
    padding-top: 35%
}
.clearbutton{
   float:right;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    color: white;
    cursor: pointer;
   border-radius:5px;
   padding: 3px 20px 3px 20px;

}
.labelright{
    float:right
}
@media  (max-width: 1100px){
    #column{
        width: 100%
    }
}

</style>
